import type * as React from "react";

const FOCUSABLE_SELECTOR = [
  "a[href]",
  "button:not([disabled])",
  "textarea:not([disabled])",
  "input:not([disabled])",
  "select:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
].join(",");

export const getFocusableElements = (container: HTMLElement | null) => {
  if (!container) return [];

  return Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter(
    (element) => !element.hasAttribute("disabled") && element.getAttribute("aria-hidden") !== "true" && element.offsetParent !== null,
  );
};

export const trapFocusKeyDown = (event: React.KeyboardEvent<HTMLElement>, container: HTMLElement | null) => {
  if (event.key !== "Tab") return;

  const focusableElements = getFocusableElements(container);
  if (!focusableElements.length) {
    event.preventDefault();
    return;
  }

  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  if (event.shiftKey && document.activeElement === firstElement) {
    event.preventDefault();
    lastElement.focus();
  }

  if (!event.shiftKey && document.activeElement === lastElement) {
    event.preventDefault();
    firstElement.focus();
  }
};

export const moveFocusWithArrows = (event: React.KeyboardEvent<HTMLElement>, container: HTMLElement | null) => {
  if (!["ArrowDown", "ArrowRight", "ArrowUp", "ArrowLeft"].includes(event.key)) return;

  const focusableElements = getFocusableElements(container);
  if (!focusableElements.length) return;

  const currentIndex = focusableElements.findIndex((element) => element === document.activeElement);
  const direction = event.key === "ArrowDown" || event.key === "ArrowRight" ? 1 : -1;
  const nextIndex = currentIndex === -1 ? 0 : (currentIndex + direction + focusableElements.length) % focusableElements.length;

  event.preventDefault();
  focusableElements[nextIndex].focus();
};